<template>
  <action-sheet :opened.sync="isVisible" :keyPad="true" confirm="MCOM-0000023" :noNegativeButton="false" :use-top-border="false" @cancel="cancelClick">
    <template #content>
      <template v-show="isVisible">
        <div class="user-pass-input">
          <strong class="tit">
            <template v-if="parent.pageType == 'findId'">{{ /*고객식별정보 입력*/ $t("MACN-01-01-01-14") }}</template>
            <template v-else>{{ /*사용자 암호 입력*/ $t("MCOM-0000107") }}</template>
          </strong>

          <p class="desc" v-html="error.errMsg || parent.pageType != 'findId' ? error.errMsg : ''"></p>
          <div class="pass-input">
            <template v-for="data in textValue.length">
              <span :key="data">●</span>
            </template>
          </div>
        </div>

        <div id="div-extendui-password-socialno" class="inner_keypad_wrap" @click.stop>
          <!-- <div class="box_sckeypad"> -->
          <div :id="id" class="nppfs-keypad" :data-width="info.iw" :data-height="info.ih" :style="makeKpdStyles()" v-show="isVisible">
            <div :class="['kpd-wrap', info.type, useMultiCursor ? 'kpd-multi-cursor' : '']" :style="makeKpdWrapStyles()" @mousemove="onMultiCursorMove">
              <!-- <template v-if="isUseAria"> -->
              <img
                style="position: absolute; left: 0; top: 0; border: 0px; width: 100%; height: 100%"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAADAFBMVEX///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALI7fhAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAApJREFUCJljYAAAAAIAAfRxZKYAAAAASUVORK5CYII="
                alt="키패드"
                :id="info.keypadUuid + '_bg_img'"
                :ref="info.keypadUuid + '_bg_img'"
                :tabindex="isUseAria ? 0 : ''"
                v-if="isUseAria"
              />
              <template v-if="useMultiCursor">
                <div class="kpd-cover cursor-cover" v-show="showMultiCursorCover"></div>
                <div class="kpd-cover click-cover" v-show="showMultiCursorCover" @click="onMultiCursorClick">
                  <img class="click-image" :src="CONFIG.KEYPAD['kpd-multi-cursor-image']" />
                </div>
                <div class="cursor cursor1"></div>
                <div class="cursor cursor2"></div>
              </template>
              <template v-if="info.touch && info.touch.use">
                <transition
                  v-on:before-enter="onTouchBeforeEnter"
                  v-on:enter="onTouchEnter"
                  v-on:after-enter="onTouchAfterEnter"
                  v-on:before-leave="onTouchBeforeLeave"
                  v-on:leave="onTouchLeave"
                  v-on:after-leave="onTouchAfterLeave"
                >
                  <div class="kpd-touch" v-show="showTouchDiv">
                    <div class="kpd-button touch1" :style="makeKpdTouchStyles()"></div>
                    <div class="kpd-button touch2" :style="makeKpdTouchStyles()"></div>
                  </div>
                </transition>
              </template>
              <!-- <template v-if="info.preview && info.preview.use">
                  <div class="kpd-preview">
                    <transition
                      v-on:before-enter="onPreviewBeforeEnter"
                      v-on:enter="onPreviewEnter"
                      v-on:after-enter="onPreviewAfterEnter"
                      v-on:before-leave="onPreviewBeforeLeave"
                      v-on:leave="onPreviewLeave"
                      v-on:after-leave="onPreviewAfterLeave"
                    >
                      <div
                        v-show="showPreview"
                        :class="['preview', info.type]"
                        :style="makeKpdPreviewStyles()"
                      ></div>
                    </transition>
                  </div>
                </template>
                <template v-if="useTextPreview">
                  <div
                    class="kpd-text"
                    :data-left="info.text.dx"
                    :data-top="info.text.dy"
                    :data-width="info.text.dw"
                    :data-height="info.text.dh"
                    :data-font-size="info.text.spanFontSize"
                    :style="makeKpdTextStyles()"
                  >
                    <span class="textfield" :style="makeKpdTextSpanStyles()">{{ textPreview }}</span>
                  </div>
              </template>-->

              <template v-for="(buttonGroup, index) in items">
                <div
                  :key="index"
                  :ref="'kpd-group-' + buttonGroup.id"
                  :class="['kpd-group', buttonGroup.id]"
                  :style="makeKpdGroupStyles()"
                  v-show="buttonGroup.id === selectedButtonGroup"
                >
                  <img class="kpd-image-button" :style="makeKpdImageStyles(makeKpdImageMarginTop(buttonGroup))" aria-hidden="true" :src="info.src" />
                  <template v-for="(button, jindex) in buttonGroup.buttons">
                    <img
                      class="kpd-data"
                      :key="jindex"
                      :style="makeKpdButtonStyles(button, makeKpdImageMarginTop(buttonGroup))"
                      :data-action="button.action"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAADAFBMVEX///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALI7fhAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOwwAADsMBx2+oZAAAAApJREFUCJljYAAAAAIAAfRxZKYAAAAASUVORK5CYII="
                      @click="handleButtonAction(button, buttonGroup, jindex)"
                      @touch="handleButtonAction(button, buttonGroup, jindex)"
                      :alt="isUseAria ? buttonLabel(button) : ''"
                      :aria-label="isUseAria ? buttonLabel(button) : ''"
                      :tabindex="isUseAria ? 0 : ''"
                      :role="isUseAria ? 'button' : ''"
                    />
                  </template>
                </div>
              </template>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </template>
    </template>
    <template #footer>
      <button class="btn bottom positive" @click="FN001SupplCertn">{{ /*입력완료*/ $t("MCOM-0000023") }}</button>
    </template>
  </action-sheet>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { npDefine, npCommon, npMessage } from "./npCommon";
import npConfig from "./nos.config";
import { mapGetters } from "vuex";
import { RBF0404B40 } from "@/mixins/nosKeypad";
import Common from "@/components/basic/Common";

export default {
  name: "NOSKeypadPW",
  extends: Common,
  model: {
    prop: "value",
    event: "update",
  },
  mixins: [RBF0404B40],
  props: {
    input: {
      // type: Object,
      required: true,
    },
    keyset: {
      type: Object,
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      useyn: false,
      useynInput: null,
      parent: this.$parent.$parent,

      seedkey: "",

      textValue: "",
      hashValue: "",
      infoValue: "",
      hashKey: "",
      infoKey: "",
      formatterValue: "",
      useFormatter: false,
      useTextPreview: false,
      textPreview: "",

      info: {},
      items: [],
      data: {},
      resizeRatio: 1,
      isVisible: false,

      showPreview: false,
      previewDuration: npConfig.KEYPAD["kpd-preview-timeout"] || 3000,
      previewStyles: {},
      stopPreviewTransition: false,
      previewTransitionTimer: null,
      isPreviewAnimating: false,

      showTouchDiv: false,
      touchDuration: 1000,
      stopTouchTransition: false,
      touchTransitionTimer: null,

      selectedButtonGroup: "",

      attrs: {},
      elementName: "",
      elementForm: "document-body",
      id: "",

      useMultiCursor: false,
      showMultiCursorCover: false,
      CONFIG: npConfig,
      isMobile: npDefine.isMobileDevice(),

      checked: false,
      isError: false,
    };
  },
  computed: {
    ...mapGetters("common/supplCertn", ["getSupplCertn"]),
    ...mapFields(["siteCode"]),
    isUseAria() {
      let ret = false;
      if (npConfig.KEYPAD["kpd-use-aria-mobile"]) {
        if (npDefine.isMobileDevice()) {
          ret = true;
          // ariaAttr = "tabindex=\"0\" ";
        }
      } else if (npConfig.KEYPAD["kpd-use-aria"]) {
        ret = true;
        // ariaAttr = "tabindex=\"0\" ";
      }
      return ret;
    },
    debugData() {
      return this.value();
    },
  },
  created() {
    // console.log("Parent : ", this.input);

    this.attrs = this.input.$attrs;
    this.elementName = this.input.name || this.input.id || "element-" + this.input._uid;
    // this.elementForm = this.input.form ? this.input.form.name || "document-body" : "document-body";
    this.id = "nppfs-keypad-" + npCommon.eraseSpecialChars(this.elementName);

    // console.log("Parent Input : ", this.input.$attrs);
    this.init();
    const params = this.prepareKeypad();
    this.createKeypad(params);
    //--------------------------------------------------------------------------
    // const scurtyDeviVndrDstcd = this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd;
    // this.$store._mutations["common/supplCertn/mut003supplCertn"][0](scurtyDeviVndrDstcd);

    // if (this._.isNil(this.NOS_INSTANCE_REFERANCE)) {
    //   this.$store._mutations["common/supplCertn/mut002supplCertn"][0](
    //     new NOSController(this, {
    //       componentid: "NOS_COMPONENT",
    //       kpd: true,
    //     }),
    //   );
    // } else {
    // this.$store._mutations["common/supplCertn/mut002supplCertn"][0](this.NOS_INSTANCE_REFERANCE);
    // }
  },
  mounted() {
    // console.log("ready...");
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // console.log("beforeDestroy...");
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions(["actLoginSuccess", "actLoginCertn"]),
    /**
     * 확인 버튼 클릭시..
     */
    FN001SupplCertn: function() {
      if (this.parent.pageType == "login" || this.parent.pageType == "loginCertn") {
        //로그인
        if (this.parent.$v.$invalid || this.parent.$refs.idText.$v.$invalid) {
          return;
        }
        if (this.parent.id == "") {
          this.$set(this.error, "errMsg", this.$t(/*아이디를 입력해 주세요.*/ "MCOM-0000115"));
        } else if (this.textValue.length < this.$config.PASSWORD_MIN_LENGTH || this.textValue.length > this.$config.PASSWORD_MAX_LENGTH) {
          this.$set(this.error, "errMsg", this.$t(/*사용자암호는 6~12자리의 영문/숫자 조합입니다.*/ "validations.passwordVerify"));
        } else {
          // 거래실행 - 로그인
          if (this.siteCode == this.$config.SITECODE_OGIND) {
            // 거래실행 - 인도기업로그인
            this.$post(
              "/commonbiz/auth/actionLoginForIdPw",
              {
                userIdnfr: this.parent.id, // 사용자식별자
                _nprotected: this.parent.NOS_INSTANCE.toJSON(),
              },
              this.parent.pageType == "login" ? this.FN010 : this.FN011,
              () => {
                this.parent.password = "";
              },
            );
          } else {
            this.$post(
              "/commonbiz/auth/actionLoginForId",
              {
                userIdnfr: this.parent.id, // 사용자식별자
                ecrypUserPwd: this.tmpPw, // 비밀번호
                smphMchtlUniqNo: this.$store.state.native.smphMchtlUniqNo, // 스마트폰기기고유번호
                appTokenCtnt: this.$store.state.native.smphMchtlUniqNo, // 앱토큰내용
                pshtCtnt: this.$store.state.native.pushToken, // 푸쉬토큰내용
                appVsnnoName: this.$store.state.native.appVersionName, // 앱버전번호명
                oSzInfoCtnt: this.$store.state.native.pgmVsnno, // OS정보내용
                smphMchtlDstcd: this.$store.state.native.smphMchtlDstcd, // 스마트폰기기구분코드
                _nprotected: this.parent.NOS_INSTANCE.toJSON(),
              },
              this.parent.pageType == "login" ? this.FN010 : this.FN011,
              () => {
                this.parent.password = "";
              },
            );
          }
        }
      } else if (this.parent.pageType == "firstPwdChange") {
        //처음 비밀번호 변경
        if (this.parent.id == "") {
          this.$set(this.error, "errMsg", this.$t(/*아이디를 입력해 주세요.*/ "MCOM-0000115"));
        } else if (this.textValue.length < 8 || this.textValue.length > this.$config.PASSWORD_MAX_LENGTH) {
          if (this.siteCode == this.$config.SITECODE_OGHCM) {
            if (this.elementName == "currentPassword") {
              if (this.textValue.length < this.$config.PASSWORD_MIN_LENGTH || this.textValue.length > this.$config.PASSWORD_MAX_LENGTH) {
                this.$set(this.error, "errMsg", this.$t(/*사용자암호는 6~12자리의 영문/숫자 조합입니다.*/ "validations.passwordVerify"));
              } else {
                this.hide();
              }
            } else {
              this.$set(this.error, "errMsg", this.$t(/*8 ~ 12자리로 숫자 / 영문 대문자 / 영문 소문자의 조합*/ "MACN-02-02-03-14"));
            }
          } else {
            if (this.textValue.length < this.$config.PASSWORD_MIN_LENGTH || this.textValue.length > this.$config.PASSWORD_MAX_LENGTH) {
              this.$set(this.error, "errMsg", this.$t(/*사용자암호는 6~12자리의 영문/숫자 조합입니다.*/ "validations.passwordVerify"));
            } else {
              this.hide();
            }
          }
        } else {
          this.hide();
        }
      } else if (this.parent.pageType == "pwdChange") {
        //비밀번호 변경 및 3회오류 해제
        //추가 개발
        this.hide();
      } else if (this.parent.pageType == "findId") {
        this.hide();
      } else if (this.parent.pageType == "perInfo") {
        this.hide();
      }
    },
    /**
     * 로그인 성공 콜백
     */
    FN010: function(response) {
      this.hide();
      if (this.siteCode == this.$config.SITECODE_OGIND && response.SessionInfo.userInfo.ppsnCoprDstcd == "2") {
        this.$post("/commonbiz/auth/actionOTPCERTNBSC", { commAuth: { biz: this.$config.AUTH_03, bizParam: { userIdnfr: this.parent.id } } }, this.FN012, this.otpFail);
      } else {
        this.actLoginSuccess({ response: response, router: this.$router, route: this.$route, loginDscd: "IDPW" });
      }
    },
    /**
     * 로그인 인증 콜백
     */
    FN011: function(response) {
      this.hide();
      this.actLoginCertn({ response: response, router: this.$router, route: this.$route, routeName: this.parent.routeName, loginDscd: "IDPW" });
    },
    /**
     * 로그인 인증 콜백 - 인도 기업일 때
     */
    FN012: function(response) {
      this.actLoginSuccess({ response: response, router: this.$router, route: this.$route, loginDscd: "IDPW" });
    },
    cancelClick() {
      //초기화
      this.textValue = "";
      this.parent.password = "";
      this.parent.newPassword = "";
      this.parent.newPasswordCheck = "";
      this.hide();
    },
    handleResize() {
      this.calculateRatio();
      this.calculatePosition();
    },
    calculateRatio() {
      this.resizeRatio = 1;
      if (this.info && this.info.iw && this.info.resize && this.info.resizeRadio > 0) {
        // const bodyWidth = document.documentElement.clientWidth;
        // const bodyHeight = document.documentElement.clientHeight;
        // const bodyWidth = document.body.clientWidth;
        // const bodyHeight = document.body.clientHeight;
        // const bodyWidth = window.screen.width;
        // const bodyHeight = window.screen.height;
        const bodyWidth = window.innerWidth;
        const bodyHeight = window.innerHeight;
        const imageWidth = this.info.iw;
        // const imageHeight = this.info.ih;
        let rate = this.info.resizeRadio / 100;
        let doResize = false;
        // console.log(
        //   "Client Width/Height", bodyWidth, bodyHeight,
        //   "Image W/H", imageWidth, imageHeight,
        //   "Resized Body W", bodyWidth * rate);

        let newWidth = bodyWidth * rate;
        rate = newWidth / imageWidth;
        // let newHeight = Math.floor(imageHeight * rate);

        // 축소하기
        if (newWidth < imageWidth) {
          doResize = true;
        }
        // 확대하기(모바일 세로보기일 때만)
        else if (npDefine.isMobileDevice() && bodyWidth <= bodyHeight && newWidth >= imageWidth) {
          doResize = true;
        }

        if (doResize) {
          // console.log('[' + newWidth + '][' + newHeight + '][' + bodyWidth + '][' + bodyHeight + '][' + rate + ']');
          this.resizeRatio = rate;
        }
      }
    },
    calculatePosition() {
      const inputdiv = this.input;
      const keypaddiv = document.getElementById(this.id);
      // console.log("Keypad Div ", this.$el.getBoundingClientRect());
      // console.log("Keypad Div ", this.id);
      let parentdiv = null;
      if (keypaddiv) {
        // console.log("Keypad Div 1", keypaddiv.getBoundingClientRect());
        let found = false;
        let tempdiv = keypaddiv;
        do {
          tempdiv = tempdiv.parentElement;
          const nodeName = tempdiv ? tempdiv.nodeName.toLowerCase() : "";
          // console.log("find tempdiv 111", tempdiv, tempdiv.nodeName);
          if (tempdiv) {
            if (tempdiv && nodeName === "body") {
              // console.log("find parent 333", tempdiv);
              break;
            }
            if (nodeName === "div" && tempdiv.getAttribute("class").indexOf("nppfs-keypad-div") >= 0) {
              // console.log("find tempdiv 222", tempdiv);
              parentdiv = tempdiv;
              found = true;
            }
          } else {
            // console.log("find parent 4444", tempdiv);
            break;
          }
        } while (!found);

        if (found && parentdiv) {
          // console.log("find parent 555", parentdiv);
        }
      }

      if (inputdiv && keypaddiv && parentdiv) {
        // console.log("Parent Input ", inputdiv.getBoundingClientRect());
        // console.log("Keypad Div ", keypaddiv.getBoundingClientRect());
        // console.log("Parent Div", parentdiv.getBoundingClientRect());

        const opt = {
          mode: "layer",
          tw: 0,
          th: 0,
          resize: true,
          resizeRadio: 90,
        };
        const position = { x: "default", y: "default", deltax: 0, deltay: 5 };
        Object.assign(opt, { ...this.data.info });
        Object.assign(position, { ...this.info.position });

        // console.log("opt", opt);
        // console.log("this.info.position", this.info.position);
        // console.log("position", position);

        const resized = this.resizeRatio !== 1;
        // browser
        var bwidth = window.innerWidth;
        var bheight = window.innerHeight;
        // keypad
        const newWidth = this.info.iw * this.resizeRatio;
        const newHeight = this.info.ih * this.resizeRatio;
        var kwidth = parseInt(newWidth, 10);
        var kheight = parseInt(newHeight, 10);
        // console.log("Keypad Position Options ", opt);
        // console.log("kwidth", kwidth, "bwidth", bwidth)

        // 입력양식
        var pos1 = inputdiv.getBoundingClientRect();

        // 부모 키패드 DIV
        var pos2 = parentdiv.getBoundingClientRect();

        // 현재 키패드 DIV
        var ele3 = keypaddiv;
        // var pos3 = keypaddiv.getBoundingClientRect();

        if ("left" === position.x) {
          if (resized) {
            ele3.style.left = (bwidth - kwidth) / 2 - pos2.left + "px";
          } else {
            ele3.style.left = position.deltax - pos2.left + "px";
          }
        } else if ("right" === position.x) {
          if (resized) {
            ele3.style.left = (bwidth - kwidth) / 2 - pos2.left + "px";
          } else {
            ele3.style.left = bwidth - kwidth - position.deltax - pos2.left + "px";
          }
        } else if ("center" === position.x) {
          if (resized) {
            ele3.style.left = (bwidth - kwidth) / 2 - pos2.left + "px";
          } else {
            ele3.style.left = (bwidth - kwidth) / 2 + position.deltax - pos2.left + "px";
          }
        } else {
          if (resized) {
            let posx = (bwidth - kwidth) / 2 - pos2.left;
            ele3.style.left = posx + "px";
          } else {
            let posx = pos1.left - pos2.left + position.deltax;
            if (posx + kwidth + pos2.left + 10 > bwidth) {
              posx = bwidth - kwidth - pos2.left - 10;
              // console.log("111 pos2.left", pos2.left, "kwidth", kwidth, "bwidth", bwidth, "posx", posx);
            }
            if (posx < -1 * pos2.left) {
              // console.log("kwidth 333", kwidth, "bwidth", bwidth)
              posx = -1 * pos2.left;
            }
            ele3.style.left = posx + "px";
          }
        }

        // https://stackoverflow.com/questions/3437786/get-the-size-of-the-screen-current-web-page-and-browser-window
        // function wndsize(){
        //   var w = 0;var h = 0;
        //   //IE
        //   if(!window.innerWidth){
        //     if(!(document.documentElement.clientWidth == 0)){
        //       //strict mode
        //       w = document.documentElement.clientWidth;h = document.documentElement.clientHeight;
        //     } else{
        //       //quirks mode
        //       w = document.body.clientWidth;h = document.body.clientHeight;
        //     }
        //   } else {
        //     //w3c
        //     w = window.innerWidth;h = window.innerHeight;
        //   }
        //   return {width:w,height:h};
        // }
        // function wndcent(){
        // var hWnd = (arguments[0] != null) ? arguments[0] : {width:0,height:0};
        // var _x = 0;
        // var _y = 0;
        // var offsetX = 0;var offsetY = 0;
        // //IE
        // if(!window.pageYOffset){
        //   //strict mode
        //   if(!(document.documentElement.scrollTop == 0)){
        //     offsetY = document.documentElement.scrollTop;
        //     offsetX = document.documentElement.scrollLeft;
        //   }
        //   //quirks mode
        //   else{
        //     offsetY = document.body.scrollTop;
        //     offsetX = document.body.scrollLeft;
        //   }
        // }
        // //w3c
        // else{
        //   offsetX = window.pageXOffset;
        //   offsetY = window.pageYOffset;
        // }
        // _x = ((wndsize().width-hWnd.width)/2) + offsetX;
        // _y = ((wndsize().height-hWnd.height)/2) + offsetY;

        // return{x:_x,y:_y};
        // }

        const scrollTop = !window.pageYOffset ? (!(document.documentElement.scrollTop == 0) ? document.documentElement.scrollTop : document.body.scrollTop) : window.pageYOffset;
        if ("top" === position.y) {
          let posy = scrollTop + position.deltay - pos2.top;
          ele3.style.top = posy + "px";
        } else if ("bottom" === position.y) {
          let posy = scrollTop + bheight - kheight - position.deltay - pos2.top;
          ele3.style.top = posy + "px";
        } else if ("middle" === position.y) {
          ele3.style.top = scrollTop + (bheight - kheight) / 2 + position.deltay - pos2.top + "px";
        } else if ("auto" === position.y) {
          let posy = 0;
          // 입력양식 위치기준 키패드 높이를 합친 하단위치
          var posy1 = pos1.top + pos1.height + kheight + position.deltay;
          // 입력양식 위치기준 키패드 높이를 뺀 상단위치
          var posy2 = pos1.top - kheight - position.deltay;
          // 스크롤 왼쪽상단
          var posy3 = scrollTop;
          //      console.log('[' + pos1.top + '][' + pos1.height + '][position.deltay]-[' + posy1 + '][' + posy2 + '][' + posy3 + '][' + bheight + '][' + kheight + ']');
          if (posy1 > posy3 + bheight) {
            if (posy2 < posy3) {
              posy = pos1.top + pos1.height - pos2.top + position.deltay;
            } else {
              posy = pos1.top - kheight - pos2.top - position.deltay;
            }
          } else {
            posy = pos1.top + pos1.height - pos2.top + position.deltay;
          }
          ele3.style.top = posy + "px";
          //      console.debug('POS 1 : ' + posy1 + ', ' + posy2 + ', ' + posy3 + ' ');
        } else {
          let posy = pos1.top + pos1.height - pos2.top + position.deltay;
          ele3.style.top = posy + "px";
        }
        //ele3.style.width = kwidth + \"px\";
      }
    },
    attr(key) {
      return this.input.getAttribute(key);
      // return this.attrs[key];
    },
    makeKpdGroupStyles() {
      const styles = {};
      styles.position = "relative";
      // styles.display = index === 0 ? "block" : "none";
      styles.width = Math.floor(this.resizeRatio * this.info.iw) + "px";
      styles.height = Math.floor(this.resizeRatio * this.info.ih) + "px";
      styles.overflow = "hidden";
      return styles;
    },
    makeKpdStyles() {
      const styles = {};
      //styles.position ='absolute';
      styles.whitSpace = "normal";
      if (this.info) {
        styles.width = Math.floor(this.resizeRatio * this.info.iw) + "px";
        styles.height = Math.floor(this.resizeRatio * this.info.ih) + "px";
      }
      return styles;
    },
    makeKpdWrapStyles() {
      const styles = {};
      styles.position = "relative";
      styles.width = Math.floor(this.resizeRatio * this.info.iw) + "px";
      styles.height = Math.floor(this.resizeRatio * this.info.ih) + "px";
      styles.whitSpace = "normal";
      return styles;
    },
    makeKpdButtonBaseStyles() {
      const styles = {};
      styles.position = "absolute";
      styles.width = Math.floor(this.resizeRatio * this.info.coords.bw) + "px";
      styles.height = Math.floor(this.resizeRatio * this.info.coords.bh) + "px";
      styles.overflow = "hidden";
      // styles.border = "1px solid #f88";
      return styles;
    },
    makeKpdImageMarginTop(group) {
      let margin = 0;
      if (group.id === "upper") {
        margin = Math.floor(this.resizeRatio * this.info.ih);
      } else if (group.id === "special") {
        margin = Math.floor(this.resizeRatio * this.info.ih * 2);
      }
      return margin;
    },
    makeKpdImageStyles(margin) {
      const styles = {};
      styles.marginTop = -1 * margin + "px";
      styles.position = "absolute";
      styles.left = 0;
      styles.top = 0;
      styles.border = 0;
      styles.width = Math.floor(this.resizeRatio * this.info.iw * 2) + "px";
      styles.height = Math.floor(this.resizeRatio * this.info.ih) + "px";
      if (this.info.type === "keyboard") {
        styles.height = Math.floor(this.resizeRatio * this.info.ih * 3) + "px";
      }
      return styles;
    },
    makeKpdButtonStyles(button, marginTop) {
      const styles = this.makeKpdButtonBaseStyles();
      styles.position = "absolute";
      styles.left = Math.floor(this.resizeRatio * button.coord.x1) + "px";
      styles.top = Math.floor(this.resizeRatio * button.coord.y1 - marginTop) + "px";
      styles.width = Math.floor(this.resizeRatio * (button.coord.x2 - button.coord.x1)) + "px";
      styles.height = Math.floor(this.resizeRatio * (button.coord.y2 - button.coord.y1)) + "px";
      // styles.border = '1px solid #ff0000';
      return styles;
    },
    makeKpdTouchStyles() {
      const styles = this.makeKpdButtonBaseStyles();
      styles.backgroundColor = this.info.touch.color;
      // styles.backgroundImage = "url('" + this.info.src + "')";
      styles.opacity = this.info.touch.opacity / 100;
      styles.filter = "alpha(opacity=" + this.info.touch.opacity + ")";
      return styles;
    },
    makeKpdPreviewStyles() {
      const styles = this.previewStyles || {};
      styles.backgroundImage = "url(" + this.info.src + ")";
      return styles;
    },
    makeKpdTextStyles() {
      const styles = {};
      const tstyle = this.info.text.style.split(";");
      tstyle.forEach(style => {
        const kv = style.trim().split(":");
        if (kv.length >= 2) {
          styles[kv[0].trim()] = kv[1].trim();
        }
      });

      styles.position = "absolute";
      styles.width = Math.floor(this.resizeRatio * this.info.text.dw) + "px";
      styles.height = Math.floor(this.resizeRatio * this.info.text.dh) + "px";
      styles.left = Math.floor(this.resizeRatio * this.info.text.dx) + "px";
      styles.top = Math.floor(this.resizeRatio * this.info.text.dy) + "px";
      styles.fontSize = Math.floor(this.resizeRatio * this.info.text.spanFontSize) + "px";
      return styles;
    },
    makeKpdTextSpanStyles() {
      const styles = {};
      const tstyle = this.info.text.spanStyle.split(";");
      tstyle.forEach(style => {
        const kv = style.split(":");
        if (kv.length >= 2) {
          styles[kv[0]] = kv[1];
        }
      });
      return styles;
    },

    buttonCoord(button) {
      const coord = button.coord;
      return coord.x1 + "," + coord.y1 + "," + coord.x2 + "," + coord.y2;
    },
    buttonPreCoord(button) {
      const coord = button.preCoord;
      return coord.x1 + "," + coord.y1 + "," + coord.x2 + "," + coord.y2;
    },
    buttonLabel(button) {
      return button.label || "키패드";
    },

    init() {
      // if(this.attr("nppfs-npv")) return;
      // if(this.input.$el.classList.contains("nppfs-npv")) return;
      if (this.input.classList.contains("nppfs-npv")) return;

      this.seedkey = this.keyset.seedkey;
      var av = this.attr(npConfig.E2E_ATTR_NAME);
      if (npConfig.KEYPAD["kpd-e2e-mode"] === "inca-double-encrypt" && av == "db") {
        this.seedkey = this.keyset.seedkey3rd;
      }

      var msVersion = navigator.userAgent.match(/MSIE ([0-9]{1,}[.0-9]{0,})/),
        msie = !!msVersion;
      this._isOldIe = (msie && parseInt(msVersion[1], 10) <= 8) || document.documentMode <= 8;
      this._isVeryOldIe = (msie && parseInt(msVersion[1], 10) <= 7) || document.documentMode <= 7;
    },
    prepareKeypad(mode) {
      const _this = this;
      const type = this.input.type || "text";

      function attr(key) {
        return _this.attr(key);
      }

      var ret = {};
      var keypadConst = {
        TYPE_KEYPAD: "p",
        TYPE_KEYBOARD: "b",
        TYPE_KOREAN: "k",
        ENABLE_FOCUS: "f",
        ENABLE_RADIO: "r",
        ENABLE_CHECKBOX: "c",
        ENABLE_TOGGLE: "t",
        SHOW_LAYER: "l",
        SHOW_BLOCK: "b",
        SHOW_DIVISION: "d",
        EXEC_PLAIN: "l",
        EXEC_PASSWORD: "p",
        EXEC_CONFIRM: "c",
        EXEC_AMOUNT: "m",
        EXEC_ACCOUNT: "a",
        EXEC_NUMBER: "n",
        EXEC_SAFECARD: "s",
        EXEC_REPLACE: "r",
      };

      // // 현대카드 UI확장기능(라온의 attribute를 NOS attribute로 변경) by YGKIM 2015.09.10
      // if(!!__extensions && typeof(__extensions.keypadUiModifier) == "function") {
      //   //console.log("현대카드 UI확장기능(라온의 attribute를 NOS attribute로 변경) by YGKIM 2015.09.10");
      //   __extensions.keypadUiModifier(element);
      // }

      var prefix = "data-keypad-";
      // var useyninput = attr(prefix + "useyn");

      ret["p"] = "p";
      ret["m"] = mode || "e";
      ret["u"] = this.uuid;
      ret["ev"] = "v4";
      ret["d"] = "nppfs-keypad-div";
      ret["jv"] = npConfig.KEYPAD["version"];

      var eletype = type.toLowerCase();
      var keypadtype = attr(prefix + "type") || "num";
      if (keypadtype == "alpha") {
        ret["t"] = keypadConst.TYPE_KEYBOARD;
      } else if (keypadtype == "korean") {
        ret["t"] = keypadConst.TYPE_KOREAN;
      } else {
        ret["t"] = keypadConst.TYPE_KEYPAD;
      }

      // <%--
      // // 치환값을 그대로 보여주는 것으로 변경, KCP요청사항
      //     // 문자형키패드는 텍스트입력양식에서는 사용할 수 없음
      // //    if(keypadtype == "alpha" && eletype == "text"){
      // //      console.log(npMessage.m45);
      // //      task.setState(npPfsConst.STATE_DONE);
      // //      return;
      // //    }
      // --%>
      // 한글키패드는 암호입력양식에서는 사용할 수 없음
      if (keypadtype == "korean" && eletype == "password") {
        alert(npMessage.m46);
        // console.log(npMessage.m46);
        // task.setState(npPfsConst.STATE_DONE);
        return;
      }

      var actiontype = attr(prefix + "action");
      if (actiontype == "account") {
        ret["at"] = keypadConst.EXEC_ACCOUNT;
      } else if (actiontype == "amount") {
        // if(eletype == "text" || eletype == "tel") {
        ret["at"] = keypadConst.EXEC_AMOUNT;
        // } else {
        //   ret["at"] = keypadConst.EXEC_REPLACE;
        // }
        //    } else if(actiontype == "safecard") {
        //      ret["at"] = keypadConst.EXEC_SAFECARD;
        //    } else if(actiontype == "confirm") {
        //      ret["at"] = keypadConst.EXEC_CONFIRM;
      } else if (actiontype == "number") {
        ret["at"] = keypadConst.EXEC_NUMBER;
      } else if (actiontype == "replace") {
        ret["at"] = keypadConst.EXEC_REPLACE;
      } else if (keypadtype == "num" && (eletype == "text" || eletype == "tel")) {
        ret["at"] = keypadConst.EXEC_NUMBER;
      } else if (keypadtype == "alpha" && eletype == "text") {
        ret["at"] = keypadConst.EXEC_PLAIN;
      } else if (actiontype == "password" || actiontype == "pin") {
        ret["at"] = keypadConst.EXEC_PASSWORD;
      } else {
        ret["at"] = keypadConst.EXEC_REPLACE;
      }

      var showtype = attr(prefix + "show");
      if (showtype == "div") {
        ret["st"] = keypadConst.SHOW_DIVISION;
        ret["dp"] = "show";
      } else if (showtype == "block") {
        ret["st"] = keypadConst.SHOW_BLOCK;
        ret["dp"] = "hide";
      } else {
        ret["st"] = keypadConst.SHOW_LAYER;
        ret["dp"] = "hide";
      }

      var useyntype = attr(prefix + "useyn-type");
      var useyninput = attr(prefix + "useyn-input");

      // "version" : "1.13.0",
      // "use-npk" : true,
      // "kpd-run-type" : "dual",

      // if(npConfig.KEYPAD["use-npk"]) {
      //   if(npConfig.KEYPAD["kpd-run-type"] !== "dual") {
      //     // 키보드보안이 실행중이고
      //     if(npKCtrl.isRunning()) {
      //       return;
      //     }

      //     // 키보드보안이 미실행중이고 활성화방식이 미지정인경우 focus로 지정하여 마우스입력기 강제사용.
      //     if(npCommon.isBlank(useyntype)) {
      //       useyntype = "focus";
      //     }
      //   } else {
      //     var av = attr(npConfig.E2E_ATTR_NAME);
      //     if(av === "mo") {
      //       if(npCommon.isBlank(useyntype) || npCommon.isBlank(useyninput)) {
      //         useyntype = "focus";
      //       }
      //     } else if(npKCtrl.isRunning()) {
      //       if(npConfig.KEYPAD["kpd-useyn-type"] === "toggle") {
      //         if(npCommon.isBlank(useyntype) || npCommon.isBlank(useyninput)) {
      //           useyntype = "toggle";
      //           useyninput = npCommon.eraseSpecialChars(this.elementName) + "_" + npQuery(form).attr("name") + "_toggle_";
      //         }
      //       } else if(npConfig.KEYPAD["kpd-useyn-type"] === "checkbox") {
      //         if(npCommon.isBlank(useyntype) || npCommon.isBlank(useyninput)) {
      //           useyntype = "checkbox";
      //           useyninput = npCommon.eraseSpecialChars(this.elementName) + "_" + npQuery(form).attr("name") + "_checkbox_";
      //         }
      //       } else {
      //         if(!npCommon.isBlank(useyntype) && npCommon.isBlank(useyninput)) {
      //           alert(npMessage.m77.replace("%p1%", this.elementName).replace("%p1%", prefix + "useyn-input"));
      //         }
      //       }
      //       var executetype = attr("npexecutetype");
      //       if(executetype== "v"){
      //         useyntype = "focus";
      //       }else if(npCommon.isBlank(useyntype) || useyntype == "focus" || !npCommon.isBlank(useyntype) && npCommon.isBlank(useyninput)) {
      //         //console.log("마우스입력기 등록 취소 : " + this.elementName);
      //         return;
      //       }
      //     } else {
      //       if(npCommon.isBlank(useyntype) || npCommon.isBlank(useyninput)) {
      //         useyntype = "focus";
      //       }
      //     }
      //   }
      // }

      if (!npCommon.isBlank(useyntype) && useyntype !== "focus" && npCommon.isBlank(useyninput)) {
        alert(npMessage.m77.replace("%p1%", this.elementName).replace("%p1%", prefix + "useyn-input"));
        return;
      }
      //console.log("[" + elementName + "][" + useyntype + "][" + useyninput + "]["+("data-keypad-useyn-input" == prefix + "useyn-input")+"]");

      if (useyntype == "toggle") {
        ret["ut"] = keypadConst.ENABLE_TOGGLE;
        ret["ui"] = useyninput;
        var toggleActive = attr(prefix + "toggle-active");
        var toggleOn = attr(prefix + "toggle-on");
        var toggleOff = attr(prefix + "toggle-off");

        toggleOn = npCommon.isBlank(toggleOn) ? npConfig.KEYPAD["kpd-toggle-image-on"] : toggleOn;
        toggleOff = npCommon.isBlank(toggleOff) ? npConfig.KEYPAD["kpd-toggle-image-off"] : toggleOff;
        ret["ta"] = npCommon.isBlank(toggleActive) ? "false" : toggleActive;
        ret["to"] = toggleOn;
        ret["tf"] = toggleOff;

        // console.log("Toggle", this.parent.$refs);
        let found = false;
        if (this.parent.$refs) {
          Object.keys(this.parent.$refs).some(key => {
            const children = this.parent.$refs[key];
            // console.log(children.id, useyninput);
            if (children && key === useyninput) {
              found = true;
              this.useynInput = children;
              return false;
            }
          });
        }
        if (found) {
          // console.log("UseYn Input", this.useynInput);
        } else {
          console.log("지정된 사용여부설정 입력양식을 찾을 수 없습니다. Vue에서는 동적 사용여부설정 자동생성 기능이 제공되지 않습니다.");
          ret["ut"] = keypadConst.ENABLE_FOCUS;
        }

        // let button = npCommon.findElement(useyninput, this.elementForm);
        // if(npCommon.isNull(button)) {
        //   if(npConfig.KEYPAD["kpd-useyn-type"] === "toggle") {
        //     let template = npConfig.KEYPAD["kpd-toggle-template"];
        //     template = template.split("#id#").join(useyninput);
        //     template = template.split("#image#").join(toggleOff);
        //     // npQuery(element).after(npQuery("<span>"+ template + "</span>"));
        //     // npQuery(element).attr({"data-keypad-useyn-type" : "toggle", "data-keypad-useyn-input" : useyninput}).addClass("nppfs-dynamic-field");
        //   }
        // }
      } else if (useyntype == "checkbox") {
        //alert(useyninput + "["+("data-keypad-useyn-input" == prefix + "useyn-input")+"]");
        // ret["ut"] = keypadConst.ENABLE_CHECKBOX;
        // ret["ui"] = useyninput;
        console.log("ratio 타입의 사용여부설정 기능은 Vue에서는 제공되지 않습니다.");
        ret["ut"] = keypadConst.ENABLE_FOCUS;
        /*
        let button = npCommon.findElement(useyninput, this.elementForm);
        if(npCommon.isNull(button)) {
          if(npConfig.KEYPAD["kpd-useyn-type"] === "checkbox") {
            let template = npConfig.KEYPAD["kpd-checkbox-template"];
            template = template.split("#id#").join(useyninput);
            template = template.split("#image#").join(toggleOff);
            // npQuery(element).after(npQuery("<span>"+ template + "</span>"));
            // npQuery(element).attr({"data-keypad-useyn-type" : "checkbox", "data-keypad-useyn-input" : useyninput}).addClass("nppfs-dynamic-field");
          }
        }
        */
      } else if (useyntype == "radio") {
        // ret["ut"] = keypadConst.ENABLE_RADIO;
        // ret["ui"] = useyninput;
        console.log("ratio 타입의 사용여부설정 기능은 Vue에서는 제공되지 않습니다.");
        ret["ut"] = keypadConst.ENABLE_FOCUS;
      } else {
        // 활성화방식이 미지정인경우 focus로 지정하여 마우스입력기 강제사용.
        ret["ut"] = keypadConst.ENABLE_FOCUS;

        this.useyn = true;
        this.input.readOnly = true;
        this.input.classList.remove(npConfig.KEYPAD["kpd-active-class"]);
        this.input.classList.add(npConfig.KEYPAD["kpd-active-class"]);
      }

      var inputrange = attr(prefix + "input-range");
      if (keypadtype == "alpha" && !npCommon.isBlank(inputrange)) {
        ret["ir"] = inputrange;
      }

      var usepreview = attr(prefix + "preview");
      if (!npCommon.isBlank(usepreview)) {
        ret["up"] = usepreview;
      }

      // ret["f"] = npQuery(form).attr("data-nppfs-form-id");
      ret["f"] = this.elementForm;
      ret["i"] = this.elementName;
      ret["il"] = attr("maxlength");
      ret["ni"] = attr(prefix + "next");
      ret["th"] = attr(prefix + "theme");
      ret["x"] = attr(prefix + "x");
      ret["y"] = attr(prefix + "y");
      ret["tx"] = attr(prefix + "type-x");
      ret["ty"] = attr(prefix + "type-y");
      ret["cf"] = attr(prefix + "enter");
      ret["ln"] = attr(prefix + "language");
      ret["w"] = document.body.offsetWidth;
      ret["h"] = document.body.offsetHeight;

      // 2017.01.05 시각 장애인 지원
      if (npConfig.KEYPAD["kpd-use-aria"]) {
        if (npConfig.KEYPAD["kpd-use-aria-mobile"]) {
          ret["ar"] = npDefine.isMobileDevice() ? "true" : "false";
        } else {
          ret["ar"] = "true";
        }
      } else {
        ret["ar"] = attr(prefix + "aria");
      }

      // 2018.07.03 데이터 맵핑 pjh -> mapping , ui 변경
      var usemapping = attr(prefix + "mapping");
      if (!npCommon.isBlank(usemapping)) {
        ret["um"] = usemapping;
      }

      function makeimageurl() {
        var src = npConfig.APPLICATION_URL;
        if (src.indexOf("http:") != 0 && src.indexOf("https:") != 0 && src.indexOf("//:") != 0) {
          var full = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
          src = full + src;
        }
        return src + "?p=p";
      }
      ret["ip"] = makeimageurl();

      npConfig.isAbsoluteUse(function(res) {
        // console.log(".....", npConfig.isAbsoluteUse())
        if (res === true) {
          this.useyn = true;
          this.input.readOnly = true;
        }
      });

      // var taskName = "task_" + npQuery(element.form).attr("name") + "_" + npQuery(element).attr("name");
      // if(npCommon.indexOf(remainTask, taskName) < 0) {
      //   remainTask.push(taskName);
      // }

      // console.log(ret);
      return ret;
    },

    createKeypad(params) {
      const _this = this;
      npCommon.post(params).then(data => {
        // console.log(data);

        // 응답값에 따른 데이터 전처리
        if (typeof data === "object") {
          _this.info = data.info;
          _this.items = data.items;
        } else if (typeof data === "string") {
          const obj = JSON.parse(data);
          _this.info = obj.info;
          _this.items = obj.items;
        }

        const items = _this.items.map(el => {
          if (el.id === "special") {
            const buttons = el.buttons.map(e => {
              if (e.action === "action:show:lower") {
                e.action = "action:show:upper";
                return e;
              }
              return e;
            });
            return {
              ...el,
              buttons: buttons,
            };
          }
          return el;
        });
        _this.items = items;

        // 동적 필드.
        if (this.info.dynamic && Array.isArray(this.info.dynamic)) {
          this.info.dynamic.forEach(item => {
            var key = item.k;
            var val = item.v;

            if (key.startsWith("__KI_")) {
              var av = this.attr(npConfig.E2E_ATTR_NAME);
              var name = this.elementName;
              if (npConfig.KEYPAD["kpd-e2e-mode"] === "inca-double-encrypt" && av == "db") {
                key = "__KIEXT_" + name;
              }
              this.infoKey = key;
              this.infoValue = val;
            } else if (key.startsWith("__KH_")) {
              this.hashKey = key;
            }
          });
        }

        // 처음에 보일 키패드 형태(대문자,소문자,특수문자,숫자)

        // console.log("Range " + _this.id, _this.info.range);

        if (!_this.selectedButtonGroup) {
          if (_this.info.type === "keyboard") {
            _this.selectedButtonGroup = "upper";
            const range = _this.info.range;
            if (range && range.startsWith("lower")) {
              _this.selectedButtonGroup = "lower";
            } else if (range && range.startsWith("upper")) {
              _this.selectedButtonGroup = "upper";
            } else if (range && range.startsWith("special")) {
              _this.selectedButtonGroup = "special";
            }
          } else {
            _this.selectedButtonGroup = "number";
          }
        }

        // 값 표시 형식 사용여부
        if (typeof npConfig["FORMATTER"] === "function" && this.attr("nppfs-formatter-type")) {
          this.useFormatter = true;
        }
        // console.log("this.useFormatter", this.useFormatter, this.attr("nppfs-formatter-type"));

        // 입력값 미리보기
        _this.useTextPreview = _this.info.text && _this.info.text.use === true && _this.attr("data-keypad-text") === "on";
        // console.log("this.useTextPreview : ", this.useTextPreview);

        // this.input.$attrs["nppfs-npv"] = "true";
        // this.input.$el.classList.add("nppfs-npv");
        this.input.setAttribute("nppfs-npv", "true");
        this.input.classList.add("nppfs-npv");
        // console.log(this.input.$attrs);
        // console.log(this.input);

        // 다중 마우스 커서
        if (npConfig.KEYPAD["kpd-multi-cursor"]) {
          _this.useMultiCursor =
            true &&
            !npDefine.isMobileDevice() && // PC 환경에서만 다중커서 사용가능(모바일은 커서 자체가 없음)
            !(npDefine.win && npDefine.sf) && // 오래된 브라우저인 윈도우 사파리 브라우저에서는 cursor=none;이 동작안함
            !(npDefine.win && this._isOldIe); // 오래된 브라우저인 윈도우 IE8 이하 브라우저에서는 cursor=none;이 동작안함
        }
        // 다중 마우스 커서 이벤트 등록
        if (this.useMultiCursor) {
          this.initMultiCursor();
        }
        // console.log("this.useuseMultiCursor", this.useMultiCursor);

        // 포커스 모드가 clear 일 경우 값 초기화
        if (_this.info.focusmode === "clear") {
          // console.log("clear.......111......");
          _this.clear(false);
        }

        // 이미지 비율 계산
        this.calculateRatio();

        return;

        //                // 데이터 맵핑 데이터 저장
        //               if (!npCommon.isNull(json.actionItems)) {
        //                 var key= json.actionItems.substring(0,64);
        //                 var data = json.actionItems.substring(64);
        //                 var val = npCommon.decrypt(npCommon.hexDecode(data), npCommon.hexDecode(key), "ECB", AES.blackSizeInBits);
        //                 var action = JSON.parse(val);
        //                 putActionItems(element, action);
        //               }

        //               var executetype =npQuery(element).attr("npexecutetype");
        //               if((typeof(executetype) != "undefined" && executetype.indexOf("k") == -1) && (typeof(npKCtrl) != "undefined" && npKCtrl.isRunning())){
        //                 if(executetype == "v"){
        //                   npVCtrl.setKeypadUse(npQuery(element).attr("name"),true);
        //                 }
        //               }

        //               npQuery(document).trigger({
        //                 type: "nppfs-npv-after-regist-field"
        //                 , message: npMessage.m78.replace("%p1%", element.name)
        //                 , target : element
        //                 , form : npQuery(form).attr("name")
        //                 , name : element.name
        //                 , time: new Date()
        //               });
      });
    },

    handleButtonAction(button, group, index) {
      const action = button.action;
      if (!action) return;

      if (action.startsWith("action")) {
        const subaction = action.substring(7);
        // console.log(subaction);

        if (subaction.startsWith("show")) {
          const layer = subaction.substring(5);
          this.selectedButtonGroup = layer;
        } else if (subaction.startsWith("hide")) {
          this.hide();
        } else if (subaction.startsWith("close")) {
          this.close();
        } else if (subaction.startsWith("delete")) {
          const formatterType = this.attr("nppfs-formatter-type");
          if (this.useFormatter) {
            this.textValue = npConfig["FORMATTER"](formatterType, this.textValue, false);
          }

          if (this.attr("data-keypad-action") == "amount") {
            this.textValue = npCommon.uncomma(this.textValue);
          }

          var ival = this.textValue;
          var hval = this.hashValue;
          var fval = this.formatterValue;
          // if(this.seedkey !== "") {
          this.textValue = ival.substring(0, ival.length - 1);
          this.hashValue = hval.substring(0, hval.length - 96);
          if (this.useTextPreview) {
            this.textPreview = this.textPreview.substring(0, this.textPreview.length - 1);
          }
          // } else {
          //   this.textValue = ival.substring(0, ival.length - 1);
          //   this.hashValue = hval.substring(0, hval.length - 40);
          // }

          if (this.useFormatter) {
            this.textValue = npConfig["FORMATTER"](formatterType, this.textValue, true);
            this.formatterValue = fval.substring(0, fval.length - 1);
            if (this.useTextPreview) {
              this.textPreview = this.textValue;
            }
          }

          if (this.attr("data-keypad-action") == "amount") {
            this.textValue(npCommon.comma(this.textValue));
            if (this.useTextPreview) {
              this.textPreview = this.textValue;
            }
          }

          this.$emit("update", this.value());
          // $element.trigger({ type : 'keypress', which : 8, keyCode : 8 });
          // $element.trigger({ type : 'keyup', which : 8, keyCode : 8 });
        } else if (subaction.startsWith("clear")) {
          this.textValue = "";
          this.hashValue = "";
          if (this.useTextPreview) {
            this.textPreview = "";
          }
          if (this.useFormatter) {
            this.formatValue = "";
          }
          this.$emit("update", this.value());
          // $element.trigger({ type : 'keypress', which : 8, keyCode : 8 });
          // $element.trigger({ type : 'keyup', which : 8, keyCode : 8 });
        } else if (subaction.startsWith("enter")) {
          this.doEnter();
        } else if (subaction.startsWith("refresh")) {
          const params = this.prepareKeypad("s");
          params["n"] = this.info.keypadUuid;
          this.createKeypad(params);
        } else if (subaction.startsWith("link")) {
          var linkArray = subaction.split("|");
          var linkUrl = "";
          var tmpUrl = [];
          var target = linkArray[1];

          if (linkArray.length > 3) {
            for (var i = 2; i < linkArray.length; i++) {
              tmpUrl.push(linkArray[i]);
            }
            linkUrl = tmpUrl.join("|");
          } else {
            linkUrl = linkArray[2];
          }

          window.open(linkUrl, target);
        }
      } else if (action.startsWith("data")) {
        const subdata = action.substring(5);
        // console.log("keypad button event with data", subdata);

        //터치모드 추가 2016.10.27 SJO
        if (this.info.touch.use == true && !this.useMultiCursor) {
          this.touch(button, npCommon.n2b(this.info.touch.touchEventMode, "default"), group, index);
          // this.touch(button, "default", group, index);
        }

        if (this.info.preview.use == true && !this.useMultiCursor) {
          this.preview(button);
        }

        var maxlength = parseInt(this.attr("maxlength"), 10) || 0;
        var idx = subdata.indexOf(":") == -1 ? 40 : subdata.indexOf(":");
        var value = subdata.substring(0, idx);
        var disvalue = idx >= 0 && subdata.length > idx + 1 ? subdata.substring(idx + 1) : "*";

        // console.log(idx, value, disvalue, maxlength);

        if (value == "korean") {
          disvalue = String.fromCharCode(disvalue);

          if (disvalue.charCodeAt(0) < 128) {
            this.textValue = this.hashValue + disvalue;
            this.hashValue = this.hashValue + disvalue;
          } else {
            // var orgValue = this.hashValue + disvalue;
            // var arrTmp = npHangul.splitWord(orgValue, 2);
            // var returnString = npHangul.composeHangul(arrTmp[1]);
            // //console.log('putHangul 001 : [' + disvalue + '][' + orgValue + '][' + arrTmp[0] + '][' + arrTmp[1] + '][' + returnString + ']');
            // this.textValue = arrTmp[0] + returnString;
            // this.hashValue = arrTmp[0] + returnString;
          }

          this.textValue = this.hashValue;
          if (this.useTextPreview) {
            this.textPreview = this.textValue;
          }
        } else {
          const formatterType = this.attr("nppfs-formatter-type");
          var encvalue = npCommon.encrypt(value, npCommon.hexDecode(this.seedkey), "ECB");
          // console.log("encvalue : ", encvalue);

          if (disvalue.indexOf("p") == 0) {
            disvalue = String.fromCharCode(parseInt(disvalue.substring(1)));
          }

          if (this.useFormatter) {
            this.textValue = npConfig["FORMATTER"](formatterType, this.textValue, false);
          }

          if (this.attr("data-keypad-action") == "amount") {
            this.textValue = npCommon.uncomma(this.textValue);
          }

          if (maxlength <= 0 || this.textValue.length < maxlength) {
            this.textValue = this.textValue + disvalue;
            this.hashValue = this.hashValue + encvalue;

            if (this.useFormatter) {
              this.formatterValue = this.formatterValue + "1";
            }

            // var keyCode = disvalue.charCodeAt(0);
            // $element.trigger({ type : 'keypress', which : keyCode, keyCode : keyCode });
            // $element.trigger({ type : 'keyup', which : keyCode, keyCode : keyCode });

            // if(this.useTextPreview) {
            //   if(this.attr("type") == "password"){
            //     this.textPreview += "*";
            //   }else{
            //     this.textPreview += disvalue;
            //   }
            // }
          }

          // 다음 입력양식으로 이동하기
          var nextelement = this.attr("data-keypad-next");
          // console.log("Next", nextelement);

          // var datalength = (this.seedkey !== "") ? this.hashValue.length / 96 : this.hashValue.length / 40;
          var datalength = this.hashValue.length / 96;
          if (maxlength > 0 && datalength >= maxlength && !npCommon.isBlank(nextelement)) {
            if (nextelement == "__hide__") {
              // console.log("__hide__", this.info.enter);
              //max 자리까지 모두 입력 시 hide 처리 안함
              // this.hide();
            } else if (nextelement === "__doenter__") {
              // console.log("__doenter__", this.info.enter);
              this.doEnter();
            } else {
              document.getElementById(nextelement).focus();
              // npQuery("input[name='" + nextelement + "']")[0].focus();
            }
          }

          if (this.useFormatter) {
            this.textValue = npConfig["FORMATTER"](formatterType, this.textValue, true);
          }

          if (this.attr("data-keypad-action") == "amount") {
            this.textValue = npCommon.comma(this.textValue);
          }
        }

        if (this.useTextPreview) {
          this.textPreview = this.textValue;
        }

        // Shift 를 사용할 경우 대문자 키패드의 문자를 입력하면
        // 자동으로 소문자 키패드로 변경
        // console.log("Range", this.info.range);
        // if (this.info.type === "keyboard" && this.info.capslock == false && this.info.shift == true && this.selectedButtonGroup === "upper") {
        //   if (this.info.range) {
        //     if (this.info.range.startsWith("lower")) {
        //       this.selectedButtonGroup = "lower";
        //     } else if (this.info.range.startsWith("upper")) {
        //       this.selectedButtonGroup = "upper";
        //     } else if (this.info.range.startsWith("special")) {
        //       this.selectedButtonGroup = "special";
        //     } else {
        //       this.selectedButtonGroup = "lower";
        //     }
        //   } else {
        //     this.selectedButtonGroup = "lower";
        //   }
        // }

        if (this.useMultiCursor) {
          this.showMultiCursorCover = true;
        }

        this.$emit("update", this.value());
      }
    },

    doEnter() {
      if (this.info.enter === "hideall") {
        this.$emit("hideall");
      } else if (this.info.enter === "hide") {
        this.hide();
      } else if (this.info.enter.startsWith("function")) {
        let jscript = this.info.enter.substring(9);
        if (jscript === "hide") {
          this.hide();
        } else if (jscript === "hideall") {
          this.$emit("hideall");
        } else {
          try {
            if (window.execScript) {
              // FOR IE
              window.execScript(jscript);
            } else {
              window["eval"].call(window, jscript);
            }
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        console.log("Form Submit기능은 Vue에서는 제공되지 않습니다.");
        // if(this.input.tagName.toLowerCase() == "form") {
        //   this.input.submit();
        // }
      }

      // npQuery(document).trigger({
      //   type: "nppfs-npv-after-enter"
      //   , message: npMessage.m94.replace("%p1%", this.elementName)
      //   , target : this._element
      //   , name : this.elementName
      //   , form : (npCommon.isNull(this.elementForm)) ? "" : this.elementForm
      //   , time: new Date()
      // });
    },

    touch(button, touchEventMode, group, index) {
      if (npCommon.isNull(button)) return;

      const touchInfo = this.info.touch;
      // console.log("touch button", button, group);

      let delta = 0;
      if (group.id === "upper") {
        delta = this.info.ih;
      } else if (group.id === "special") {
        delta = this.info.ih * 2;
      }

      var div1 = this.$el.getElementsByClassName("touch1");
      if (div1 && div1.length > 0) {
        const coords = button.coord;
        div1[0].style.left = Math.floor(this.resizeRatio * coords.x1) + "px";
        div1[0].style.top = Math.floor(this.resizeRatio * (coords.y1 - delta)) + "px";
        div1[0].style.opacity = touchInfo.opacity / 100;
        div1[0].style.backgroundColor = touchInfo.color;
      }

      var div2 = this.$el.getElementsByClassName("touch2");
      if (div2 && div2.length > 0) {
        // div2[0].style.left = Math.floor(this.resizeRatio * sx) + "px";
        // div2[0].style.top = Math.floor(this.resizeRatio * sy) + "px";

        if (touchEventMode !== "single") {
          const anotherButtons = [];
          group.buttons.forEach((btn, idx) => {
            if (btn.type === "data" && idx !== index) {
              anotherButtons.push(btn);
            }
          });

          var ri = anotherButtons.length <= 2 ? 0 : Math.round(Math.random() * anotherButtons.length * 10) % anotherButtons.length;
          var touch = anotherButtons[ri];
          const coords = touch.coord;
          div2[0].style.left = Math.floor(this.resizeRatio * coords.x1) + "px";
          div2[0].style.top = Math.floor(this.resizeRatio * (coords.y1 - delta)) + "px";
          div2[0].style.opacity = touchInfo.opacity / 100;
          div2[0].style.backgroundColor = touchInfo.color;
          div2[0].style.display = "block";
        } else {
          div2[0].style.display = "none";
        }
      }

      // if(this._isOldIe) {
      //   divtouch.css({opacity:1}).show();
      //   setTimeout(function(){
      //     divtouch.hide();
      //   }, this._keypadinfo.touch.timeout);
      // } else {
      //   divtouch.stop().animate({opacity:1}, 1);
      //   divtouch.show().animate({opacity:0}, this._keypadinfo.touch.timeout, function(){
      //     npQuery(this).hide();
      //   });
      // }

      this.touchDuration = touchInfo.timeout;
      this.showTouchDiv = true;
    },
    onTouchBeforeEnter() {
      // console.log("Preview Element beforeEnter : ", this.touchDuration, this.showPreview);
      // el.style.opacity = 1;
      this.stopTouchTransition = true;

      if (this.touchTransitionTimer) {
        clearInterval(this.touchTransitionTimer);
        this.touchTransitionTimer = null;
      }
    },
    onTouchEnter(el, done) {
      // console.log("Preview Element enter : ", this.previewDuration, this.showPreview);
      el.style.opacity = 1;
      done();
    },
    onTouchAfterEnter() {
      // el.style.opacity = 1;
      this.showTouchDiv = false;
    },
    onTouchBeforeLeave(el) {
      // console.log("Preview Element beforeLeave : ", this.touchDuration, this.showPreview);
      el.style.opacity = 1;
    },
    onTouchLeave: function(el, done) {
      // console.log("Preview Element leave : ", this.touchDuration, this.showPreview);
      const delta = 1 / (this.touchDuration / 50);
      let opacity = 1;
      el.style.opacity = opacity;

      this.touchTransitionTimer = setInterval(function() {
        if (this.stopTouchTransition) {
          clearInterval(this.touchTransitionTimer);
          this.touchTransitionTimer = null;
          this.stopTouchTransition = false;
          done();
          return;
        }

        opacity -= delta;

        el.style.opacity = opacity;
        if (opacity < 0) {
          el.style.opacity = 0;
          opacity = 0;
          clearInterval(this.touchTransitionTimer);
          this.touchTransitionTimer = null;
          done();
        }
      }, 50);
    },
    onTouchAfterLeave() {
      // console.log("Preview Element afterLeave : ", this.touchDuration, this.showPreview);
    },

    preview(button) {
      const coords = button.preCoord;
      // return coord.x1 + ',' + coord.y1 + ',' + coord.x2 + ',' + coord.y2;

      // var coords = target.attr("preCoords");
      // var pairs = coords.split(',');
      var sx = Math.ceil(coords.x1);
      var sy = Math.ceil(coords.y1);
      var ex = Math.ceil(coords.x2);
      var ey = Math.ceil(coords.y2);
      var viewWidth = ex - sx;
      var viewHeight = ey - sy;

      var previewtop = 4;
      var previewborder = npConfig.KEYPAD["kpd-preview-border"] || "2";

      // var divitem = npQuery(".kpd-preview .preview", $element.parent().parent());
      // divitem.css({"width" : viewWidth, "height" : viewHeight});

      const styles = {};
      styles.position = "absolute";
      styles.backgroundRepeat = "no-repeat";
      // styles.left = (-1 * viewWidth / 2) + "px";
      // styles.top = previewtop + "px";
      // styles.width = (viewWidth - previewborder * 2) + "px";
      // styles.height = (viewHeight - previewborder * 2) + "px";
      // styles.backgroundPosition = -(sx + 4 - previewborder) + "px " + -(sy + 4 - previewborder) + "px";

      styles.left = Math.floor(this.resizeRatio * ((-1 * viewWidth) / 2)) + "px";
      styles.top = Math.floor(this.resizeRatio * previewtop) + "px";
      styles.width = Math.floor(this.resizeRatio * (viewWidth - previewborder * 2)) + "px";
      styles.height = Math.floor(this.resizeRatio * (viewHeight - previewborder * 2)) + "px";
      styles.backgroundPosition = Math.floor(this.resizeRatio * -1 * (sx + 4 - previewborder)) + "px " + Math.floor(this.resizeRatio * -1 * (sy + 4 - previewborder)) + "px";

      const newWidth = Math.floor(this.resizeRatio * this.info.iw * 2);
      let newHeight = Math.floor(this.resizeRatio * this.info.ih);
      if (this.info.type === "keyboard") {
        newHeight = Math.floor(this.resizeRatio * this.info.ih * 3);
      }
      styles.backgroundSize = newWidth + "px " + newHeight + "px";

      this.previewStyles = styles;

      // const _this = this;
      if (this.isPreviewAnimating) {
        this.stopPreviewTransition = true;
      }
      this.showPreview = true;

      // this.$nextTick(() => {
      //   this.previewDuration = npConfig.KEYPAD["kpd-preview-timeout"] || 3000;
      // });
      // var divpreview = npQuery(".kpd-preview", $element.parent().parent());
      // if(this._isOldIe) {
      //   divpreview.css({opacity:1}).show();
      //   setTimeout(function() {
      //     divpreview.hide();
      //   }, npConfig.KEYPAD["kpd-preview-timeout"] || 3000);
      // } else {
      //   divpreview.stop().animate({opacity:1}, 1);
      //   divpreview.show().animate({opacity:0}, npConfig.KEYPAD["kpd-preview-timeout"] || 3000, function(){
      //     npQuery(this).hide();
      //   });
      // }
    },
    onPreviewBeforeEnter(el) {
      // console.log("Preview Element beforeEnter : ", this.previewDuration, this.showPreview);
      el.style.opacity = 0;
      this.isPreviewAnimating = true;
    },
    onPreviewEnter(el, done) {
      // console.log("Preview Element enter : ", this.previewDuration, this.showPreview);
      if (this.previewTransitionTimer) {
        clearInterval(this.previewTransitionTimer);
        this.previewTransitionTimer = null;
        done();
        return;
      }

      // const delta = 1 / (this.previewDuration / 100);
      const delta = 1 / (100 / 100);
      let opacity = 0;
      el.style.opacity = opacity;
      this.previewTransitionTimer = setInterval(function() {
        opacity += delta;
        el.style.opacity = opacity;
        if (opacity >= 1) {
          el.style.opacity = 1;
          opacity = 1;
          clearInterval(this.previewTransitionTimer);
          this.previewTransitionTimer = null;
          done();
        }
      }, 100);
    },
    onPreviewAfterEnter(el) {
      // console.log("Preview Element afterEnter : ", this.previewDuration, this.showPreview);
      el.style.opacity = 1;
      // this.isPreviewAnimating = false;
      this.showPreview = false;
    },
    onPreviewBeforeLeave(el) {
      // console.log("Preview Element beforeLeave : ", this.previewDuration, this.showPreview);
      this.isPreviewAnimating = true;
      el.style.opacity = 1;
    },
    onPreviewLeave: function(el, done) {
      // console.log("Preview Element leave : ", this.previewDuration, this.showPreview);
      const delta = 1 / (this.previewDuration / 100);
      let opacity = 1;
      el.style.opacity = opacity;

      if (this.previewTransitionTimer) {
        clearInterval(this.previewTransitionTimer);
        this.previewTransitionTimer = null;
      }

      this.previewTransitionTimer = setInterval(function() {
        if (this.stopPreviewTransition) {
          clearInterval(this.previewTransitionTimer);
          this.previewTransitionTimer = null;
          this.stopPreviewTransition = false;
          done();
          return;
        }

        opacity -= delta;

        el.style.opacity = opacity;
        if (opacity < 0) {
          el.style.opacity = 0;
          opacity = 0;
          clearInterval(this.previewTransitionTimer);
          this.previewTransitionTimer = null;
          done();
        }
      }, 100);
    },
    onPreviewAfterLeave(el) {
      // console.log("Preview Element afterLeave : ", this.previewDuration, this.showPreview);
      this.isPreviewAnimating = false;
      el.style.opacity = 0;
    },

    initMultiCursor() {},

    onMultiCursorMove(event) {
      if (this.useMultiCursor) {
        // console.log("event", event)

        const div = this.$el.getElementsByClassName("kpd-multi-cursor");
        const kpddiv = div && div.length > 0 ? div[0] : null;
        if (!kpddiv) return;

        console.log("vx", vx, "vy", vy);
        const vx = window.scrollX || document.documentElement.scrollLeft;
        const vy = window.scrollY || document.documentElement.scrollTop;
        var centerx = Math.floor((this.resizeRatio * this.info.iw) / 2);
        var centery = Math.floor((this.resizeRatio * this.info.ih) / 2);
        var position = kpddiv.getBoundingClientRect();
        var deltax = position.left + centerx - event.pageX + vx;
        var deltay = position.top + centery - event.pageY + vy;
        var newx1 = centerx - deltax;
        var newy1 = centery - deltay;
        var newx2 = centerx + deltax;
        var newy2 = centery + deltay;

        const c1div = kpddiv.getElementsByClassName("cursor1");
        const c2div = kpddiv.getElementsByClassName("cursor2");
        if (c1div && c1div.length > 0) {
          c1div[0].style.cursor = "none";
          c1div[0].style.left = newx1 + "px";
          c1div[0].style.top = newy1 + "px";
        }
        if (c2div && c2div.length > 0) {
          c2div[0].style.cursor = "none";
          c2div[0].style.left = newx2 + "px";
          c2div[0].style.top = newy2 + "px";
        }
      }
    },

    onMultiCursorClick() {
      this.showMultiCursorCover = false;
    },

    serialize() {
      const ret = {};
      ret[this.hashKey] = this.hashValue;
      ret[this.infoKey] = this.infoValue;
      ret[this.elementName] = this.textValue;
      // ret[this.useyninput] = this.textValue;
      ret[this.info.inputs.useyn] = "Y";
      return ret;
    },
    value() {
      return {
        id: this.elementName,
        textValue: this.textValue,
        formatterValue: this.formatterValue,
        hashKey: this.hashKey,
        hashValue: this.hashValue,
        infoKey: this.infoKey,
        infoValue: this.infoValue,
        selectedButtonGroup: this.selectedButtonGroup,
        useTextPreview: this.useTextPreview,
        useFormatter: this.useFormatter,
      };
    },

    getHash() {
      return this.hashValue;
    },

    getInfo() {
      return this.infoValue;
    },

    getText() {
      return this.textValue;
    },

    clear(fromFocus) {
      if (!fromFocus || (fromFocus && this.info.focusmode === "clear")) {
        // if(this.textValue || this.hashValue || this.textPreview || this.formatValue) {
        this.$nextTick(() => {
          // console.log("clear.............", this.input.$el, this.input.value)
          this.textValue = "";
          this.hashValue = "";
          this.textPreview = "";
          this.formatValue = "";
          this.input.value = "";
          this.$emit("update", "");
          // }
        });
      }
    },

    show() {
      this.hide();
      this.isVisible = true;
      this.calculateRatio();
      this.calculatePosition();
      // console.log("Show " + this.isVisible);
      // if(this.isVisible) {
      this.input.style.color = npConfig.COLOR["on-text-color"];
      this.input.style.backgroundColor = npConfig.COLOR["on-back-color"];
      // } else {
      // }
      // if(this.isUseAria) {
      //   const first = this.$refs[this.info.keypadUuid + '_bg_img'];
      //   if(first) {
      //   console.log("aria....", first, "........", first.$el)
      //     if(first.$el) first.$el.focus();
      //     else first.focus();
      //     // first.$el.focus();
      //   }
      // }
    },
    hide() {
      this.setErrorModal(false);
      this.isVisible = false;
      this.input.style.color = npConfig.COLOR["off-text-color"];
      this.input.style.backgroundColor = npConfig.COLOR["off-back-color"];
      // console.log("Hide " + this.isVisible);
    },
    close() {
      if (!npConfig.KEYPAD["kpd-close-hide"]) {
        this.setUseYn(false);
      }
      this.hide();
      // console.log("Close " + this.isVisible);
    },
    focus() {
      if (this.isUseAria) {
        // const first = document.getElementById(this.info.keypadUuid + '_bg_img');
        const first = this.$refs[this.info.keypadUuid + "_bg_img"];
        if (first) {
          this.$nextTick(function() {
            if (first.$el) first.$el.focus();
            else first.focus();
            // console.log("aria....", first, "........", first.$el)
            // console.log("active", document.activeElement);
          });
        }
      }
    },
    isUseYn() {
      return this.useyn;
    },
    setUseYn(useyn) {
      const _this = this;
      // const res = npConfig.isAbsoluteUse();
      npConfig.isAbsoluteUse(function(res) {
        // 이것으로 처리하면 화면 업데이트가 안됨
        const oldUseYn = _this.useyn;

        _this.useyn = res || useyn;

        if (oldUseYn !== _this.useyn) {
          // console.log("setUseYn", this.useyn);
          _this.input.readOnly = _this.useyn;
          _this.clear(false);
        }

        _this.input.classList.remove(npConfig.KEYPAD["kpd-active-class"]);
        if (_this.useyn) {
          _this.input.classList.add(npConfig.KEYPAD["kpd-active-class"]);
        }

        if (_this.useynInput) {
          // console.log("Use Yn", _this.useynInput, _this.useynInput.text);
          _this.useynInput.classList.remove(npConfig.KEYPAD["kpd-active-class"]);
          if (_this.useyn) {
            _this.useynInput.classList.add(npConfig.KEYPAD["kpd-active-class"]);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
}

.inner_keypad_wrap {
  position: fixed;
  z-index: 1004;
  left: 0;
  bottom: 48px;
  width: 100%;
  height: auto;
  /* padding: 30px 20px 20px 20px; */
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 15px 15px 0 0;
  transition: bottom 0.7s;
}

.box_sckeypad {
  position: relative;
  height: auto;
  /* margin-top: 50px; */
  letter-spacing: -6px;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
